module.exports = __webpack_public_path__ + "img/word-cloud.92d343fd.png";